import { render, staticRenderFns } from "./DirectDebit.vue?vue&type=template&id=0ea380cb&scoped=true&"
import script from "./DirectDebit.vue?vue&type=script&lang=js&"
export * from "./DirectDebit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea380cb",
  null
  
)

export default component.exports